import { Avatar, Card, Tag } from "antd";
import { PdfIcon } from "../../../../../../atoms/CustomIcons";

export default function TabActivity() {
  return (
    <div className="dashboardTabContent">
      <Card style={{ borderRadius: "16px", border: "unset" }}>
        <h3 style={{ marginBottom: "16px" }}> Activity </h3>
        <div className="notes_activity_sidebar">
          <div className="content_bar">
            <Card className="activity_card grey_client_card">
              <div className="profile_avatar">
                <Avatar
                  size={32}
                  shape="square"
                  src="/images/dummy/checkList_dp_2.png"
                  className="profile_image"
                />

                <div>
                  <h2 className="profile_name">Jasper A. attached 2 files</h2>
                  <h5 className="profile_role">Operations Manager</h5>
                </div>
              </div>

              <div className="activity_time">
                <p>12:00 PM</p>
              </div>

              <div className="activity_content">
                <ul>
                  <li style={{ cursor: "pointer" }}>
                    <span className="fileType">
                      <PdfIcon />
                    </span>
                    Leadership results.pdf
                  </li>
                  <li style={{ cursor: "pointer" }}>
                    <span className="fileType">
                      <PdfIcon />
                    </span>
                    Leadership results.doc
                  </li>
                </ul>
              </div>
            </Card>
            <Card className="activity_card blue_me_card">
              <div className="profile_avatar">
                <Avatar
                  size={32}
                  shape="square"
                  src="/images/dummy/checkList_dp_3.svg"
                  className="profile_image"
                />

                <div>
                  <h2 className="profile_name">
                    Anna L. <span className="me_tag">(me)</span>
                  </h2>
                  <h5 className="profile_role">Operations Manager</h5>
                </div>
              </div>

              <div className="activity_time">
                <p>11:00 PM</p>
              </div>

              <div className="activity_content">
                <p>
                  Please trim along the fence and check irrigation timing.
                  Thanks!
                </p>
              </div>
            </Card>
            <Card className="activity_card grey_client_card">
              <div className="profile_avatar">
                <Avatar
                  size={32}
                  shape="square"
                  src="/images/dummy/checkList_dp_2.png"
                  className="profile_image"
                />

                <div>
                  <h2 className="profile_name">Jasper A.</h2>
                  <h5 className="profile_role">Operations Manager</h5>
                </div>
              </div>

              <div className="activity_time">
                <p>12:00 PM</p>
              </div>

              <div className="activity_content">
                <p className="grey_text">
                  Hi Jack, <br /> I hope you're doing well. Please find
                  attached...
                </p>
              </div>
            </Card>
            <Card className="activity_card transparent_card">
              <div className="profile_avatar">
                <div>
                  <h2 className="profile_name">
                    <b>Michael S.</b> updated{" "}
                    <a href="www.google.com"> Proposal v.3 - 03.10.2025 </a>
                    status from
                  </h2>
                </div>
              </div>

              <div className="activity_time">
                <p>09:00 PM</p>
              </div>

              <div style={{ display: "flex", gap: "8px" }}>
                <Tag className="approval_pending_tag">Inprogress</Tag>
                to <Tag className="sent_tag">Sent</Tag>
              </div>
            </Card>
          </div>
        </div>
      </Card>
    </div>
  );
}
